import queryString from 'query-string'
import getRequest from '../../getRequest'

export default function overridePassword(record, password) {
  let endpoint = ''
  if (record.role === 'Student') {
    endpoint = 'Student'
  } else {
    endpoint = 'Educator'
  }
  const data = {
    id: record.id,
    password,
  }
  console.log('data', data)
  const query = queryString.stringify(data)
  const url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAdd${endpoint}?${query}`
  return getRequest(url)
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/overridePassword.js